import { DIBOT_SESSION_ID_KEY } from './constants';

const mintSessionId = (): string => crypto.randomUUID();

export const getDibotSessionId = (): string | null => {
	if (typeof window === 'undefined') return null;
	try {
		return window.sessionStorage.getItem(DIBOT_SESSION_ID_KEY);
	} catch {
		return null;
	}
};

export const startDibotSession = (): string | null => {
	if (typeof window === 'undefined') return null;
	const sessionId = mintSessionId();
	try {
		window.sessionStorage.setItem(DIBOT_SESSION_ID_KEY, sessionId);
	} catch {
		return sessionId;
	}
	return sessionId;
};

export const clearDibotSession = (): void => {
	if (typeof window === 'undefined') return;
	try {
		window.sessionStorage.removeItem(DIBOT_SESSION_ID_KEY);
	} catch {
		return;
	}
};
